import { render, staticRenderFns } from "./lazyblock_subscription.vue?vue&type=template&id=4af920c6&scoped=true"
import script from "./lazyblock_subscription.vue?vue&type=script&lang=js"
export * from "./lazyblock_subscription.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_subscription.vue?vue&type=style&index=0&id=4af920c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af920c6",
  null
  
)

export default component.exports